import { useState } from "react";

export const numberFormatter = () => {
    const currency = new Intl.NumberFormat('id-ID', {
        prefix: "$",
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })

    return {
        currency
    };
}

export default numberFormatter;